export default "__VITE_ASSET__CBD1gX6J__"